<section>
  <app-expert-group-portal-header
    *ngIf="expertGroupPortal"
    selectedNavItem="experts"
    [expertGroupPortal]="expertGroupPortal"
  ></app-expert-group-portal-header>
  <div class="container m-b-xxl m-t-alt">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h2 class="title is-2 mb-0">Experts</h2>
        <div *ngIf="page?.content" [innerHTML]="page?.content"></div>
        <div *ngIf="loadingPage">
          <div
            class="mt-6 temporary-item temporary-item--dark temporary-desc"
          ></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
      </div>
    </div>
    <div class="card has-background-white-ter pb-0 mb-6">
      <div class="card-content">
        <app-author-filter
          *ngIf="selectedParams"
          [formParams]="selectedParams"
          [currentPath]="baseUrl"
          [filterByWorkingGroup]="false"
        ></app-author-filter>
      </div>
    </div>

    <div class="columns is-multiline">
      <ng-container *ngIf="authors">
        <div
          class="column is-6-mobile is-4-tablet is-3-desktop"
          *ngFor="let author of authors"
        >
          <app-author-card
            [author]="author"
            [authorImage]="author.image"
          ></app-author-card></div
      ></ng-container>
      <ng-container *ngIf="authors?.length === 0">
        <div class="column">No experts found with the selected filters.</div>
      </ng-container>
    </div>
    <app-expert-list-loader
      *ngIf="loading"
      class="columns is-multiline"
    ></app-expert-list-loader>
  </div>
</section>
